import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSidebarSimpleLeftWide"><Path d="M2.5 4.5H21.5V19.5H2.5V4.5Z" stroke="currentColor"/><Path d="M7.5 4.5V12V19.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleLeftWide;
